/**
 * Common Media Object Type
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
export var CmObjectType;
(function (CmObjectType) {
    /**
     * text file, such as a manifest or playlist
     */
    CmObjectType["MANIFEST"] = "m";
    /**
     * audio only
     */
    CmObjectType["AUDIO"] = "a";
    /**
     * video only
     */
    CmObjectType["VIDEO"] = "v";
    /**
     * muxed audio and video
     */
    CmObjectType["MUXED"] = "av";
    /**
     * init segment
     */
    CmObjectType["INIT"] = "i";
    /**
     * caption or subtitle
     */
    CmObjectType["CAPTION"] = "c";
    /**
     * ISOBMFF timed text track
     */
    CmObjectType["TIMED_TEXT"] = "tt";
    /**
     * cryptographic key, license or certificate.
     */
    CmObjectType["KEY"] = "k";
    /**
     * other
     */
    CmObjectType["OTHER"] = "o";
})(CmObjectType || (CmObjectType = {}));
//# sourceMappingURL=CmObjectType.js.map